const extractSelection = (cursorSelection, editorState) => {
  if (!cursorSelection) {
    return null
  }

  const { startOffset, endOffset } = cursorSelection
  const plainText = editorState.getCurrentContent().getPlainText()

  return {
    range: {
      start: 0,
      end: endOffset
    },
    text: {
      beforeCursor: plainText.slice(0, startOffset),
      afterCursor: plainText.slice(endOffset)
    }
  }
}

export default extractSelection
